import React, { useState } from 'react';
import { TBaseDropdownOption, TBaseDropdownProps } from './BaseDropdown.types';

import { BaseGenericModal } from 'src/components/BaseGenericModal';
import { BaseList } from 'src/components/BaseList';
import classnames from 'classnames';
import { closeModal } from 'src/redux/modals/modals.slice';
import s from './BaseDropdown.module.scss';
import { useAppDispatch } from 'src/redux/store';

export const BaseDropdown: React.FC<TBaseDropdownProps> = ({
  options,
  defaultItem,
  onSelect,
  modalId,
  position = 'top',
  className,
}: TBaseDropdownProps) => {
  const [activeItem, setActiveItem] = useState(() => {
    return options.find((item) => item.label === defaultItem?.label);
  });

  const dispatch = useAppDispatch();

  const isItemActive = ({ value }: TBaseDropdownOption) => activeItem?.value === value;

  const onItemClick = (item: TBaseDropdownOption) => {
    dispatch(closeModal(modalId));
    setActiveItem(item);
    onSelect?.(item.value);
  };

  return (
    <BaseGenericModal
      size="auto"
      modalId={modalId}
      singleActionModal
      inline={true}
      className={classnames(s.container, s[position], className)}>
      <BaseList width="100%" className={s.list}>
        {options.map((item, index) => (
          <div
            key={index}
            className={classnames(s.item, { [s.itemActive]: isItemActive(item) })}
            onClick={() => {
              onItemClick(item);
            }}>
            <button type="button">{item.label}</button>
          </div>
        ))}
      </BaseList>
    </BaseGenericModal>
  );
};
